// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItem_container__9KxST","selected":"MenuItem_selected__1ZO03"};